<template>
  <div :class="[$style.message, $style[align]]">
    <div :class="$style.meta">
      <div :class="$style.photoContainer">
        <img v-if="contact" :src="contact.photoUrl || defaultAvatar" :alt="contact.name" />
        <img v-else :src="defaultAvatar" alt="" />
      </div>
    </div>
    <div ref="message" :class="$style.msgContainer">
      <div v-html="message"></div>
      <p :class="$style.time">{{ time }}</p>
    </div>
    <span v-if="resendInProgress" :class="$style.resend">
      <FontAwesomeIcon :icon="faClock" />
    </span>
    <button
      v-else-if="failed"
      @click="resend"
      :class="$style.resend">
      <FontAwesomeIcon :icon="faExclamationTriangle" />
      resend
    </button>
  </div>
</template>

<script>
  import moment from 'moment'
  import { linkifyElement } from 'vue-components/utils/linkify'
  import defaultAvatar from '@/assets/img/default-avatar.svg'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
  import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'

  export default {
    components: {
      FontAwesomeIcon
    },
    props: ['activity'],
    data () {
      return {
        faClock,
        faExclamationTriangle,
        defaultAvatar,
        resendInProgress: false
      }
    },
    computed: {
      align () {
        return this.activity.type === 'sms-outbound' ? 'right' : 'left'
      },
      contact () {
        return this.activity.type === 'sms-outbound' ? this.activity.organizer : this.activity.prospect
      },
      message () {
        return this.activity.message.replace(/\n/g, '<br />')
      },
      time () {
        return moment(this.activity.sentAt || this.activity.receivedAt).calendar()
      },
      failed () {
        return ['failed', 'undelivered'].includes(this.activity.status)
      }
    },
    mounted () {
      linkifyElement(this.$refs.message)
    },
    methods: {
      resend () {
        this.resendInProgress = true
        this.$emit('resend', this.activity)
      }
    },
    watch: {
      activity () {
        this.resendInProgress = false
      }
    }
  }
</script>

<style module lang="less" src="./message.less"></style>



// WEBPACK FOOTER //
// message.vue?62108fb8